const AA_FETCHING_ASSIGNMENT = 'AA_FETCHING_ASSIGNMENT'
const AA_FETCHING_ASSIGNMENT_SUCCESS = 'AA_FETCHING_ASSIGNMENT_SUCCESS'
const AA_FETCHING_ASSIGNMENT_ERROR = 'AA_FETCHING_ASSIGNMENTS_ERROR'

export function fetchingAssignment () {
  return {
    type: AA_FETCHING_ASSIGNMENT,
  }
}

export function fetchingAssignmentSuccess(assignment) {
  return {
    type: AA_FETCHING_ASSIGNMENT_SUCCESS,
    assignment,
  }
}

export function fetchingAssignmentError(error) {
  return {
    type: AA_FETCHING_ASSIGNMENT_ERROR,
    error,
  }
}

const initialState = {
  assignment: null,
  userAssignment: null,
  error: '',
  isFetching: false,
}

export function assignmentsAssignment (state = initialState, action) {
  switch (action.type) {
    case AA_FETCHING_ASSIGNMENT :
      return {
        ...state,
        isFetching: true,
      }
    case AA_FETCHING_ASSIGNMENT_SUCCESS :
      return {
        ...state,
        isFetching: false,
        assignment: action.assignment.assignment,
        userAssignment: action.assignment.userAssignment,
      }
    case AA_FETCHING_ASSIGNMENT_ERROR :
      return {
        ...state,
        isFetching: false,
        error: action.error,
        assignment: null,
        userAssignment: null,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/assignmentsAssignment.js